import React from 'react';
import { Spinner, Typography } from 'glints-aries/es/@next';
import { Blue } from 'glints-aries/es/@next/utilities/colors';
import { FormattedMessage } from 'react-intl';

import styles from './SessionInitializer.scss';

const LoadingFullscreen = () => (
  <div className={styles.spinWrapper}>
    <Spinner fill={Blue.S99} size="large" />
    <Typography variant="body2">
      <FormattedMessage
        id="components.LoadingFullscreen.loading"
        defaultMessage="Loading&hellip;"
      />
    </Typography>
  </div>
);

export default LoadingFullscreen;
